// extracted by mini-css-extract-plugin
module.exports = {"container":"Summary--container--3UnfX"};